import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import API from "../services/api";

export default function FeeHistory() {

    const [payments, setPayments] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 20;

    const [loading, setLoading] = useState(false);

    const [studentName, setStudentName] =
        useState("");

    const [studentId, setStudentId] =
        useState("");

    const [className, setClassName] =
        useState("");

    const [section, setSection] =
        useState("");

    const [fromDate, setFromDate] =
        useState("");

    const [toDate, setToDate] =
        useState("");

  

    const location = useLocation();

    const queryStudentId = new URLSearchParams(
        location.search
    ).get("student");


    //<div className="flex flex-wrap gap-3 mb-5">

    //    <button
    //        onClick={() => {

    //            const today = new Date().toISOString().split("T")[0];

    //            setFromDate(today);
    //            setToDate(today);

              

    //        }}
    //        className="bg-green-600 text-white px-4 py-2 rounded-lg"
    //    >
    //        Today
    //    </button>

    //    <button
    //        onClick={() => {
    //            setFilterType("YESTERDAY");
    //            searchHistory("YESTERDAY");
    //        }}
    //        className="bg-blue-600 text-white px-4 py-2 rounded-lg"
    //    >
    //        Yesterday
    //    </button>

    //    <button
    //        onClick={() => {
    //            setFilterType("MONTH");
    //            searchHistory("MONTH");
    //        }}
    //        className="bg-purple-600 text-white px-4 py-2 rounded-lg"
    //    >
    //        This Month
    //    </button>

    //    <button
    //        onClick={() => {
    //            setFilterType("ALL");
    //            searchHistory("ALL");
    //        }}
    //        className="bg-gray-600 text-white px-4 py-2 rounded-lg"
    //    >
    //        All
    //    </button>

    //</div>


    /* =========================
       SEARCH HISTORY
    ========================= */

    const searchHistory = async (
        customFromDate,
        customToDate
    ) => {

        if (customFromDate?.target) {

            customFromDate = fromDate;
            customToDate = toDate;

        }

        customFromDate = customFromDate || fromDate;
        customToDate = customToDate || toDate;  

        try {

            setLoading(true);

            const res = await API.get(

                "/payments/search/history",

                {
                    params: {

                        student_name: studentName,

                        student_id: studentId,

                        class_name: className,

                        section: section,

                        fromDate: customFromDate,

                        toDate: customToDate

                    }
                }
            );



            setPayments(res.data);

        } catch (err) {

            console.log(err);

            alert("Unable to fetch history");

        } finally {

            setLoading(false);
        }
    };

    const exportExcel = () => {

        const params = new URLSearchParams({

            student_name: studentName,

            student_id: studentId,

            class_name: className,

            section,

            fromDate,

            toDate

        });

        window.open(

            `http://localhost:3001/api/payments/export/excel?${params.toString()}`,

            "_blank"

        );

    };

    useEffect(() => {

        if (!queryStudentId) return;

        setStudentId(queryStudentId);

        const loadStudentHistory = async () => {

            try {

                setLoading(true);

                const res = await API.get(

                    "/payments/search/history",

                    {
                        params: {

                            student_id: queryStudentId

                        }
                    }

                );

                setPayments(res.data);

            } catch (err) {

                console.log(err);

            } finally {

                setLoading(false);

            }

        };

        loadStudentHistory();

    }, [queryStudentId]);


    /* =========================
       TOTAL PAID
    ========================= */

    const totalPaid = payments.reduce(

        (sum, item) =>

            sum +
            Number(item.amount_paid || 0),

        0
    );
    const indexOfLastRecord =
        currentPage * recordsPerPage;

    const indexOfFirstRecord =
        indexOfLastRecord - recordsPerPage;

    const currentPayments =
        payments.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );

    const totalPages =
        Math.ceil(
            payments.length /
            recordsPerPage
        );

    const pageTotal =
        currentPayments.reduce(

            (sum, item) =>

                sum +
                Number(item.amount_paid || 0),

            0

        );


    return (

        <div className="p-6 bg-gray-100 min-h-screen">

            {/* Header */}

            <div className="mb-6">

                <h1 className="text-3xl font-bold text-gray-800">

                    Fee Payment History

                </h1>

                <p className="text-gray-500 mt-1">

                    Search by student,
                    class and section

                </p>

            </div>


            <div className="flex gap-3 mb-5">

                <button
                    onClick={() => {

                        const today = new Date()
                            .toISOString()
                            .split("T")[0];

                        setFromDate(today);
                        setToDate(today);

                        searchHistory(today, today);

                    }}
                    className="bg-green-600 text-white px-4 py-2 rounded-lg"
                >
                    Today
                </button>

                <button
                    onClick={() => {

                        const d = new Date();

                        d.setDate(d.getDate() - 1);

                        const yesterday =
                            d.toISOString().split("T")[0];

                        setFromDate(yesterday);
                        setToDate(yesterday);
                        searchHistory(yesterday, yesterday);

                    }}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg"
                >
                    Yesterday
                </button>

                <button
                    onClick={() => {

                        const now = new Date();

                        const firstDay =
                            new Date(
                                now.getFullYear(),
                                now.getMonth(),
                                1
                            )
                                .toISOString()
                                .split("T")[0];

                        const today =
                            now.toISOString()
                                .split("T")[0];

                        setFromDate(firstDay);
                        setToDate(today);
                        searchHistory(firstDay, today);

                    }}
                    className="bg-purple-600 text-white px-4 py-2 rounded-lg"
                >
                    This Month
                </button>

            </div>

            {/* Search Filters */}

            <div className="bg-white rounded-2xl shadow p-6 mb-6">

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

                    <input
                        type="text"
                        placeholder="Student Name"
                        value={studentName}
                        onChange={(e) =>
                            setStudentName(e.target.value)
                        }
                        className="border p-3 rounded-xl"
                    />



                    <input
                        type="text"
                        placeholder="Student ID"
                        value={studentId}
                        onChange={(e) =>
                            setStudentId(e.target.value)
                        }
                        className="border p-3 rounded-xl"
                    />



                    <select
                        value={className}
                        onChange={(e) =>
                            setClassName(e.target.value)
                        }
                        className="border p-3 rounded-xl"
                    >

                        <option value="">
                            All Classes
                        </option>

                        <option>PP1</option>
                        <option>PP2</option>
                        <option>LKG</option>
                        <option>UKG</option>

                        {
                            [...Array(10)].map((_, i) => (

                                <option key={i}>
                                    {i + 1}
                                </option>
                            ))
                        }

                    </select>



                    <select
                        value={section}
                        onChange={(e) =>
                            setSection(e.target.value)
                        }
                        className="border p-3 rounded-xl"
                    >

                        <option value="">
                            All Sections
                        </option>

                        <option>A</option>
                        <option>B</option>
                        <option>C</option>

                    </select>

                    <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        className="border p-3 rounded-xl"
                    />

                    <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        className="border p-3 rounded-xl"
                    />

                </div>


                <div className="mt-5 flex gap-4">

                    <button
                        onClick={() => searchHistory()}
                        className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-xl font-semibold"
                    >
                        {
                            loading
                                ? "Searching..."
                                : "Search History"
                        }
                    </button>

                    <button
                        onClick={exportExcel}
                        className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl font-semibold"
                    >
                        Export Excel
                    </button>

                </div>

            </div>



            {/* Summary */}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">

                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-green-600">

                    <p className="text-gray-500">
                        Total Records
                    </p>

                    <h2 className="text-3xl font-bold mt-2">
                        {payments.length}
                    </h2>

                </div>



                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-blue-600">

                    <p className="text-gray-500">
                        Total Collection
                    </p>

                    <h2 className="text-3xl font-bold mt-2">
                        ₹{totalPaid}
                    </h2>

                </div>

            </div>



            {/* Table */}

            <div className="bg-white rounded-2xl shadow p-6 overflow-x-auto">

                <table className="w-full border-collapse border">

                    <thead>

                        <tr className="bg-gray-100">

                            <th className="border p-3">
                                Student
                            </th>

                            <th className="border p-3">
                                Class
                            </th>

                            <th className="border p-3">
                                Term
                            </th>

                            <th className="border p-3">
                                Amount
                            </th>

                            <th className="border p-3">
                                Balance
                            </th>

                            <th className="border p-3">
                                Mode
                            </th>

                            <th className="border p-3">
                                Updated By
                            </th>

                            <th className="border p-3">
                                Date
                            </th>

                        </tr>

                    </thead>



                    <tbody>

                        {
                            payments.length === 0 ? (

                                <tr>

                                    <td
                                        colSpan="8"
                                        className="text-center p-8 text-gray-500"
                                    >

                                        No records found

                                    </td>

                                </tr>

                            ) : (

                               currentPayments.map((payment) => (

                                    <tr
                                        key={payment.id}
                                        className="border-b text-center hover:bg-gray-50"
                                    >

                                        <td className="p-3">

                                            {
                                                payment.student_name
                                            }

                                        </td>

                                        <td className="p-3">

                                            {
                                                payment.class_name
                                            }

                                        </td>

                                        <td className="p-3">

                                            {payment.term}

                                        </td>

                                        <td className="p-3 font-semibold">

                                            ₹{payment.amount_paid}

                                        </td>

                                        <td className="p-3 text-red-600 font-bold">

                                            ₹{payment.current_balance}

                                        </td>

                                        <td className="p-3">

                                            {
                                                payment.payment_mode
                                            }

                                        </td>

                                        <td className="p-3">

                                            {
                                                payment.updated_by
                                            }

                                        </td>

                                        <td className="p-3">

                                            {
                                                new Date(
                                                    payment.payment_date
                                                ).toLocaleDateString()
                                            }

                                        </td>

                                    </tr>
                                ))
                            )
                        }

                    </tbody>

                </table>

                <div className="flex justify-between items-center mt-6">

                    <button

                        disabled={currentPage === 1}

                        onClick={() =>
                            setCurrentPage(currentPage - 1)
                        }

                        className="bg-gray-200 px-4 py-2 rounded disabled:opacity-50"

                    >

                        ◀ Previous

                    </button>

                    <div className="font-semibold">

                        Page {currentPage} of {totalPages}

                    </div>

                    <button

                        disabled={currentPage === totalPages}

                        onClick={() =>
                            setCurrentPage(currentPage + 1)
                        }

                        className="bg-gray-200 px-4 py-2 rounded disabled:opacity-50"

                    >

                        Next ▶

                    </button>

                </div>

                <div className="mt-5 bg-blue-50 rounded-xl p-5">

                    <div className="flex justify-between">

                        <strong>

                            Page Total

                        </strong>

                        <strong>

                            ₹{pageTotal}

                        </strong>

                    </div>

                    <div className="flex justify-between mt-3">

                        <strong>

                            Grand Total

                        </strong>

                        <strong>

                            ₹{totalPaid}

                        </strong>

                    </div>

                </div>

            </div>

        </div>
    );
}